import React from 'react';
import WebhookSettings from './webhookSettings';
import MicrosoftTeamsSettings from './microsoftTeamsSettings';
import HarvestSettings from './harvestSettings';
import TeamworkSettings from './teamworkSettings';
import SlackSettings from './slackSettings';
import TrelloSettings from './trelloSettings';
import JiraSettings from './jiraSettings';
import GithubSettings from './githubSettings';
import AsanaSettings from './asanaSettings';
import ClickupSettings from './clickupSettings';
import MondaySettings from './mondaySettings';
import ProductiveSettings from './productiveSettings';
import LinearSettings from './linearSettings';
import { VisibleModal } from '.';

type IntegrationConfig = {
  SettingsComponent: React.ComponentType<any>;
  reconnect?: boolean;
  propKeys?: string[];
  displayName?: string;
  hasCommonProps?: boolean;
  checkEnabled?: 'legacy';
  integrationKey?: string;
  checkKey?: string | string[];
};

const nativeIntegration = (
  SettingsComponent: React.ComponentType<any>,
  displayName: string,
  extra: Partial<IntegrationConfig> = {}
): IntegrationConfig => ({
  SettingsComponent,
  reconnect: true,
  displayName,
  hasCommonProps: true,
  ...extra
});

export const INTEGRATIONS_CONFIG: {
  [key in VisibleModal]: IntegrationConfig;
} = {
  webhooks: {
    SettingsComponent: WebhookSettings,
    propKeys: ['projectId', 'webhooks', 'webhooksPath', 'container', 'apiKey']
  },
  harvest: {
    SettingsComponent: HarvestSettings,
    propKeys: ['harvestIntegration', 'handleHarvestClick']
  },
  teams: {
    SettingsComponent: MicrosoftTeamsSettings,
    hasCommonProps: true,
    integrationKey: 'team'
  },
  teamwork: {
    SettingsComponent: TeamworkSettings,
    hasCommonProps: true
  },
  slack: {
    SettingsComponent: SlackSettings,
    reconnect: true,
    propKeys: ['justUpgradedSlack'],
    displayName: 'Slack',
    hasCommonProps: true,
    checkEnabled: 'legacy',
    integrationKey: 'slack',
    checkKey: 'slacklegacy'
  },
  trellonative: nativeIntegration(TrelloSettings, 'Trello', {
    propKeys: ['onDisconnect']
  }),
  jiranative: nativeIntegration(JiraSettings, 'Jira'),
  github: {
    SettingsComponent: GithubSettings,
    propKeys: ['onDisconnect'],
    hasCommonProps: true
  },
  asananative: nativeIntegration(AsanaSettings, 'Asana', {
    propKeys: ['onDisconnect']
  }),
  clickupnative: nativeIntegration(ClickupSettings, 'ClickUp', {
    propKeys: ['onDisconnect', 'container']
  }),
  linearnative: nativeIntegration(LinearSettings, 'Linear', {
    propKeys: ['onDisconnect']
  }),
  mondaynative: nativeIntegration(MondaySettings, 'Monday', {
    propKeys: ['onDisconnect']
  }),
  productivenative: nativeIntegration(ProductiveSettings, 'Productive')
};
